import React from 'react';
import { useTranslation } from 'react-i18next'; // Pour i18n
import AboutUs from '../../components/About';
import Contact from '../../components/Contact';
import SectionWithImageLeft from '../../components/SectionWithImageLeft';
import Vision from '../../components/Vision';
import OurValues from '../../components/OurValues';

function About() {
  const { t } = useTranslation(); 

  return (
    <div className="space-y-16 mt-24 py-18"> 
      <AboutUs />

      <SectionWithImageLeft 
        sectionTitle={t('Aboutpage.Mission.sectionTitle')} 
        title={t('Aboutpage.Mission.title')}
        spanTitle={t('Aboutpage.Mission.spanTitle')}
        description={t('Aboutpage.Mission.description')} 
        image="/images/illustration.png"
      />

      <Vision 
        sectionTitle={t('Aboutpage.Vision.sectionTitle')} 
        title={t('Aboutpage.Vision.title')}
        spanTitle={t('Aboutpage.Vision.spanTitle')}
        description={t('Aboutpage.Vision.description')} 
        image="/images/finance.png"
      />

      <OurValues />
      <Contact />
    </div>
  );
}

export default About;
